/*
 * Author: Danny Ehlers
 * Date: 8/15/2018
 * Route guard with Oath2 support.
 */
import { Injectable } from '@angular/core';
//import { OpenIdConnectService } from './open-id-connect.service';
import { Router } from '@angular/router';
import { AuthService } from './auth.service';

@Injectable()
export class RequireAuthenticationUserRouteGuardServiceService {

  constructor(
    private authService: AuthService,
    private router: Router) { }

  canActivate() {
    

    //if (this.openIdConnectService.userAvailable) {
    //  return true;
    //  // DE (8/15/2018): The user account in the client gets lost if the user book marks the page and it loads.
    //  // I added code to reload the user so it stays current.
    //} else if (!this.openIdConnectService.userAvailable && this.openIdConnectService.getAccessToken().length > 10) {
    //    this.openIdConnectService.reloadUser();
    //    return true;
    //} else {
    //  this.openIdConnectService.triggerSignIn();
    //  return false;
    //}
  }

}
